import { render } from "./AddressSuggestions.vue?vue&type=template&id=007cd66c"
import script from "./AddressSuggestions.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressSuggestions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/injectComponents/AddressSuggestions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "007cd66c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('007cd66c', __exports__)) {
    api.reload('007cd66c', __exports__)
  }
  
  module.hot.accept("./AddressSuggestions.vue?vue&type=template&id=007cd66c", () => {
    api.rerender('007cd66c', render)
  })

}


export default __exports__